const PREFIX = '@@zedux/';
export const zeduxTypes = {
    batch: `${PREFIX}batch`,
    delegate: `${PREFIX}delegate`,
    hydrate: `${PREFIX}hydrate`,
    ignore: `${PREFIX}ignore`,
    inherit: `${PREFIX}inherit`,
    merge: `${PREFIX}merge`,
    prime: `${PREFIX}prime`,
};
